import CncForm from './CncForm';
import './CncForm.css';
export default CncForm;
